module.exports = __webpack_public_path__ + "img/1.ea3a9ba2.svg";